/**
 * Mixin for centralized validation of INTEGER numeric inputs
 * Validates fields: UNITS, surfaceInput, LINEAL_METERS
 * - Only allows positive integers > 0
 * - Does not allow decimals (. or ,)
 * - Does not allow 0 or negative numbers
 */
export const numericInputValidation = {
  data() {
    return {
      VALIDATED_NUMERIC_FIELDS: ['UNITS', 'surfaceInput', 'LINEAL_METERS']
    }
  },

  methods: {
    shouldValidateNumericField(fieldName) {
      return this.VALIDATED_NUMERIC_FIELDS.includes(fieldName)
    },

    sanitizeNumericValue(value) {
      if (value === null || value === undefined || value === false) {
        return ''
      }
      
      let sanitized = String(value).replace(/[^\d]/g, '')
      
      if (/^0+$/.test(sanitized)) {
        return ''
      }
      
      sanitized = sanitized.replace(/^0+/, '')
      
      if (sanitized === '' || sanitized === '0') {
        return ''
      }
      
      const numValue = parseInt(sanitized, 10)
      if (isNaN(numValue) || numValue <= 0) {
        return ''
      }
      
      return sanitized
    },

    isValidNumericValue(value) {
      if (value === null || value === undefined || value === '' || value === false) {
        return false
      }
      
      const numValue = parseInt(value, 10)
      return !isNaN(numValue) && numValue > 0
    },

    preventInvalidNumericKeys(event) {
      const allowedKeys = [
        'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
        'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
        'Home', 'End'
      ]
      
      if (allowedKeys.includes(event.key) || 
          event.ctrlKey || event.metaKey || event.altKey) {
        return true
      }
      
      if (!/^\d$/.test(event.key)) {
        event.preventDefault()
        return false
      }
      
      const currentValue = event.target.value || ''
      const cursorPosition = event.target.selectionStart || 0
      
      if (event.key === '0') {
        if (currentValue === '') {
          event.preventDefault()
          return false
        }
        
        if (currentValue === '0') {
          event.preventDefault()
          return false
        }
        
        if (cursorPosition === 0 && /^0+$/.test(currentValue)) {
          event.preventDefault()
          return false
        }
        
        if (event.target.selectionStart === 0 && 
            event.target.selectionEnd === currentValue.length &&
            currentValue.length > 0) {
          event.preventDefault()
          return false
        }
      }
      
      return true
    },

    handleValidatedNumericInput(event, fieldName) {
      const originalValue = event.target.value
      
      if (!this.shouldValidateNumericField(fieldName)) {
        return originalValue
      }
      
      const sanitized = this.sanitizeNumericValue(originalValue)
      event.target.value = sanitized
      
      return sanitized
    }
  }
}